/**
 * Manages the "return URL", a URL that the user is redirected to once they
 * have successfully logged in. Typically, the URL is the path the
 * unauthenticated user attempted to access before being redirected to the
 * Sign In page.
 */
export const manageReturnUrl = ({ state }, history) => {
    // If there is a referrer, save it for redirection post-authentication
    if (state && state.from !== '/') {
        sessionStorage.setItem('returnUrl', state.from);
        return;
    }

    sessionStorage.removeItem('returnUrl');
    // If there is no referrer, then bounce them so that there is
    if (!state) {
        history.replace('/');
    }
};
